import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { groupsManagement } from "../../../../hooks/api/GroupsManagement";
import { DefaultLayout } from "../../../../layouts/Default";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { toast } from "react-toastify";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { Main } from "../../../../themes/Default/components/Main";
import { Title } from "../../../../themes/Default/components/Title";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Formik } from "formik";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { Textarea } from "../../../../themes/Default/components/Form/components/Textarea";
import { Toaster } from "../../../../themes/Default/components/Toaster";
import { studentsManagement } from "../../../../hooks/api/StudentsManagement";

const ArchiveNote = () => {
    const { t } = useTranslation("common");
    const { selectedGroupId } = useParams();
    const { studentId } = useParams();
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { useArchiveParticipantMutation } = groupsManagement;
    const {  useViewStudentsMutation} = studentsManagement;
    const [viewStudents] = useViewStudentsMutation();
    const [student, setStudent] = useState();
    const [archiveGroupParticipant] = useArchiveParticipantMutation();
    
    const gotoDetailsTab = (studentId) => {
        navigate("/students/edit/" + studentId);
    };

    const gotoNotesTab = (studentId) => {
        navigate('/students/' + studentId + '/notes');
    }

    const gotoTestsTab = (studentId) => {
        navigate('/students/' + studentId + '/tests');
    }

    const gotoDocumentsTab = (studentId) => {
        navigate('/students/' + studentId + '/documents');
    }

    const gotoCertificatesTab = (studentId) => {
        navigate('/students/' + studentId + '/certificates');
    }

    const gotoContractsTab = (studentId) => {
        navigate("/students/" + studentId + "/contracts");
    };

    const gotoCallsTab = (studentId) => {
        navigate("/students/" + studentId + "/calls");
    };

    const tabs = [
        { title: t('details'), onClick: () => gotoDetailsTab(studentId) },
        // { title: t('students.tests'), onClick: () => gotoTestsTab(studentId)},
        { title: t("students.contract"), onClick: () => gotoContractsTab(studentId) },
        { title: t("calls.title"), onClick: () => gotoCallsTab(studentId) },
        { title: t('groups.title'), isActive: true},
        { title: t('students.certificates'), onClick: () => gotoCertificatesTab(studentId)},
        { title: t('documents'), onClick: () => gotoDocumentsTab(studentId)},
        { title: t('notes'), onClick: () => gotoNotesTab(studentId)},
    ];

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onArchive = (values) => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("Da li ste sigurni da želite da arhivirate polaznika u ovoj grupi?")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        const body = {
                            ...values,
                        }; 
                        archiveGroupParticipant({groupId: selectedGroupId, participantId: studentId, body}).then((result) => {
                            if (result?.error) {
                                setFormErrors(result?.error?.data?.error?.violations);
                                toast.error(result.error.data.error.responseMessage);
                            } else {
                                navigate("/students/" + studentId + "/groups");
                            }
                        });
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    useEffect(() => {
        viewStudents(studentId).then((result) => {
            setStudent(result?.data);
        });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to={"/students/" + studentId + "/groups"} />
                <Button title={t("Arhiviraj polaznika u grupi")} icon="fa-regular fa-box-archive" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{student?.firstName} {student?.lastName}</Title>
                <Breadcrumps>
                    <Link title={t('students.title')} icon="fa-user-graduate" />
                    <Link title={t('details')} />
                    <Link title={t('groups.title')} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        note: "",
                    }}
                    onSubmit={onArchive}
                >
                    {({ values, handleChange, setFieldValue }) => (
                        <Form>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Textarea
                                        rows={6}
                                        name="note"
                                        label={t("groups.reasonForArchiving")}
                                        required={true}
                                        value={values.note}
                                        onChange={handleChange}
                                        error={formErrors?.note}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default ArchiveNote;